import {ChangeEvent, ReactElement} from 'react'
import {WithNamespaces, withNamespaces} from 'react-i18next'
import {eachMonthOfInterval, startOfMonth} from 'date-fns'
import {Grid, FormControl, Select, MenuItem, capitalize} from '@material-ui/core'
import {formatDate} from '../../../../../../../common/utils'
import {Provider} from '../../../../hooks/useProvider'
import {useStyles} from './styles'

type DateSelectBaseProps = {
  value: string
  provider: Provider
  onChange: (nextValue: string) => void
}

type DateSelectProps = DateSelectBaseProps & WithNamespaces

const Component = (props: DateSelectProps): ReactElement => {
  const {lng, value, provider, onChange} = props

  const classes = useStyles()

  const startOfCopying = provider.startedAt != null ? new Date(provider.startedAt) : new Date()

  const availableDates = eachMonthOfInterval({
    start: startOfMonth(startOfCopying),
    end: new Date()
  })

  const dateOptions = availableDates.map(date => ({
    value: date.toISOString(),
    label: formatDate(lng, date, {month: 'long', year: 'numeric'})
  }))

  const handleChange = (e: ChangeEvent<{ value: unknown }>) => {
    onChange(e.target.value as string)
  }

  return (
    <Grid item md={3} xs={12}>
      <FormControl fullWidth>
        <Select
          value={value}
          onChange={handleChange}
          align='left'
          classes={{select: classes.select}}
        >
          {dateOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {capitalize(option.label)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  )
}

export const DateSelect = withNamespaces()(Component)
